/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 08:59:54
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-15, 16:31:25
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
// import ENUM from "es6-enum";
// import { createAction } from "helpers/utils";

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/settings.js